import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-e9fa0952"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "home"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.userTerms, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(item.type)
    }, _toDisplayString($data.lang == 'hk' ? item.hkText : item.enText), 3);
  }), 256))]);
}